<template>
  <div class="sticky-wrapper" ref="stickyWrapper">
    <section 
      class="category-links-section"
      :class="{ 'is-sticky': isSticky }"
      :style="stickyStyle"
      ref="categoryNav"
    >
      <div class="category-links-wrap" >
        <div class="category-links-div">
          <div class="links-group-1">
            <a
              v-for="(cat, index) in categories"
              :key="`cathead-click-${index}`"
              :href="`#${cat}`"
              class="category-page-link w-inline-block"
              @click.prevent="scrollToCategory(cat)"
            >
              <div :class="`category-dot ${cat.toLowerCase()}`"></div>
              <div class="text-block-867">{{ cat }}</div>
            </a>
          </div>
        </div>
      </div>
    </section>
    <!-- Spacer div to prevent content jump when nav becomes sticky -->
    <div v-if="isSticky" :style="{ height: navHeight + 'px' }"></div>
  </div>
</template>

<script>
export default {
  name: 'CategoryNav',
  
  props: {
    categories: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      isSticky: false,
      navHeight: 0,
      navOffset: 0,
      mainNavHeight: 0
    }
  },

  computed: {
    stickyStyle() {
      return this.isSticky ? {
        top: `${this.mainNavHeight}px`
      } : {}
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.navHeight = this.$refs.categoryNav.offsetHeight;
      this.navOffset = this.$refs.stickyWrapper.offsetTop;
      this.mainNavHeight = document.querySelector('.nav').offsetHeight;
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.updateDimensions);
      this.checkCatinURL();
    });
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.updateDimensions);
  },

  methods: {
    handleScroll() {
      this.isSticky = window.pageYOffset > this.navOffset;
    },
    
    checkCatinURL(){
      if(this.$route.query.category){
        this.$nextTick(() => {
          this.scrollToCategory(this.$route.query.category);
        });
      }
    },
    
    updateDimensions() {
      this.navHeight = this.$refs.categoryNav.offsetHeight;
      this.navOffset = this.$refs.stickyWrapper.offsetTop;
      this.mainNavHeight = document.querySelector('.nav').offsetHeight;
    },

    scrollToCategory(category) {
      const element = document.getElementById(category);
      if (element) {
        const offset = this.navHeight + this.mainNavHeight + 20;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth'
        });
      }
    }
  }
}
</script>

<style>

.sticky-wrapper {
  position: relative;
  
}

.category-links-section {
  background: white;
  width: 100%;
  transition: all 0.3s ease;
}

.category-links-section.is-sticky {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 998; /* Just below main nav */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Ensure links remain clickable */
.category-links-wrap {
  position: relative;
  z-index: 999;
}

/* Make sure category dots and text are visible */
.category-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}

.category-page-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 8px 16px;
  margin: 0 8px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}
.category-links-section {
  transform: translateZ(0);
  will-change: transform;
}
@media screen and (max-width: 479px) {
  .text-block-867 {
      font-size: 12px;
  }
}
</style>